import { Dialog, DialogTitle, Typography, IconButton, DialogContent, Box, TextField, Grid, DialogActions, Button } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from "@mui/icons-material/Close";


interface AccountVerificationProps {
    open: boolean;
    onProceed: () => void;
    onClose: () => void;
}

const AccountVerification: React.FC<AccountVerificationProps> = ({ open, onClose, onProceed }) => {
    const [otp, setOtp] = useState(new Array(6).fill(""));

    const handleChange = (index: any, event: any) => {
        const { value } = event.target;
        const newOtp = [...otp];
        newOtp[index] = value.slice(-1);
        setOtp(newOtp);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth sx={{
            "& .MuiDialog-paper": {
                maxWidth: "506px",
                borderRadius: "16px",
                position: "relative",
            },
        }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "20px",
                }}
            >
                <Typography
                    sx={{
                        fontSize: {
                            xs: "22px",
                        },
                        fontWeight: "500",
                        color: "#333333",
                    }}
                >
                    Account verification
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: "#666",
                        position: "absolute",
                        top: "12px",
                        right: "16px",
                        "&:hover": {
                            color: "#000",
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent sx={{ padding: "32px 20px", borderBottom: "1px solid #E8EAF0" }}>
                <Typography color='#010101' fontSize='18px' textAlign='center' mb='32px'> Enter the 6-digit code we just sent to your phone *********01</Typography>
                <Box display="flex" gap="12px" justifyContent="center" mb='27px' flexWrap='wrap'>
                    {otp.map((value, index) => (
                        <TextField
                            key={index}
                            value={value}
                            onChange={(event) => handleChange(index, event)}
                            sx={{
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#F0F0F0",
                                }
                            }}
                            slotProps={{
                                input: {
                                    style: {
                                        backgroundColor: "#F0F0F0",
                                        width: "48px",
                                        height: "48px",
                                        padding: "14px",
                                        textAlign: "center",
                                        fontSize: "18px",
                                        borderRadius: "8px",
                                        fontWeight: "bold",
                                    },
                                },
                            }}
                        />
                    ))}
                </Box>
                <Typography color='#1272CA' fontSize='15px' textAlign='center' fontWeight='500'>Resend code in 00:20 sec</Typography>
            </DialogContent>
            {/* Dialog Actions */}
            <DialogActions
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "27px 20px 20px 20px",
                }}
            >
                <Button
                    variant="outlined"
                    color="primary"
                    sx={{
                        textTransform: "capitalize",
                        px: "24px",
                        borderRadius: "8px",
                        border: "1px solid #E8EAF0",
                        color: "#2B2B30",
                        mr: "16px",
                        height: "47px!important",
                    }}
                >
                    Back
                </Button>

                <Button variant="contained" className="x-large-btn" disableElevation sx={{
                    textTransform: "capitalize", borderRadius: "8px", px: "28px", height: "47px!important", '&:hover': {
                        backgroundColor: '#1fbf62',
                    }
                }} onClick={onProceed}>
                    Proceed
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default AccountVerification
